export let PlacesOutageMessage = "itjz9d";
export default {PlacesOutageMessage};